module.exports = __webpack_public_path__ + "static/pi07-bf0d77d95db9a877437de5d153f877a5.png";